<style>
.centered-content {
    text-align: center;
    align-items: center;
}

.divPromo {
    margin-top: 2vw;
    /* Margen superior del 2% del ancho de la ventana */
    height: 100%;
    /* Altura del 10% de la altura de la ventana */
    width: 100%;
    /* Ancho del 50% del ancho de la ventana */
    border: 0.1em solid #7C8BE1;

    /* Borde de 0.2 em */
}

.hPromo {
    width: 10%;
    /* Ancho del 10% del contenedor padre */
    font-size: 1.5vw;
    /* Tamaño de fuente del 1.5% del ancho de la ventana */
    margin-top: -0.8em;
    /* Margen superior de -0.8 em */
    margin-right: 1vw;
    margin-left: 1.2vw;
    /* Margen izquierdo del 1% del ancho de la ventana */
    background: white;
}

.promotions-container {
    margin-top: 20px;
}

.promotion-item {
    background-color: #ffffff;
    border: 1px solid #ddd;
    padding: 20px;
    margin-bottom: 20px;
}

.promotion-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.product-image {
    text-align: center;
}

.product-frame {
    max-width: 100%;
    height: auto;
}

.card-body {
    padding: 0;
}

.card-title {
    margin-bottom: 10px;
}

.card-text {
    margin-bottom: 5px;
}

.no-border {
    border: none !important;
    /* Utiliza !important para asegurar que se aplique */
    box-shadow: none !important;
    /* También puedes quitar la sombra si es necesario */
}

.full-width-image {
    width: 100%;

}

.header-title {
    font-size: 24px;
    color: #ff9900;
}

.divider {
    border-top: 3px solid #ff9900;
    width: 70%;
    margin: 0 auto;

}
</style>

<template>
    <div style="margin-top: 5%; margin-bottom: 5%;" v-if="promociones.length > 0">
        <!-- Contenido dividido en dos columnas -->
        <div class="row" style="--bs-gutter-x: 0;">
            <!-- Columna izquierda para la imagen -->
            <div class="col-md-4 d-flex d-sm-block align-items-center justify-content-center">
                <!-- Aquí va la imagen a tamaño completo -->
                <img src="images/font/51983.jpg" alt="Imagen" class="full-width-image">
            </div>
            <!-- Columna derecha para el título y el slider -->
            <div class="col-md-8" style="background: rgba(6, 40, 60, 0.8);">
                <div class="centered-content">
                    <h1 class="header-title">Promociones</h1>
                    <!-- Línea divisoria -->
                    <hr class="divider">
                </div>
                <!-- Aquí va el slider de promociones -->
                <div class="promotions-container">
                    <carousel v-bind="settings" :breakpoints="breakpoints">
                        <slide v-for="(item, index) in promociones" :id="index" :key="index">
                            <div class="card"
                                style="border: none !important;box-shadow: none !important;background-color: transparent;">
                                <router-link :to="{ name: 'detalleProducto', query: { claveprod: item.k_parte } }"
                                    style="font-size:22px;border: none;color:#06283c; text-decoration: none; color: inherit;">
                                    <!-- Renderizar la información del producto -->
                                    <div class="card-img-top" v-if="item.PicturesUrl[4]">
                                        <!-- Establece un alto fijo para la imagen -->
                                        <img alt="Placeholder Image" class="product-frame"
                                            v-bind:src='item.PicturesUrl[4].sm' style="height: 150px;">
                                    </div>
                                    <div class="card-img-top" v-else>
                                        <img src="/img/display/Placeholder.png" alt="Placeholder Image"
                                            class="product-frame" style="height: 150px;">
                                    </div>
                                    <div class="card-body" style="color:white">
                                        <p style="font-size: 12px;">{{ item.k_parte }}</p>
                                        <p style="font-size: 10px;">{{ item.linea }}</p>
                                    </div>
                                </router-link>
                            </div>
                        </slide>
                        <template
                            v-if="promociones.length > breakpoints[1024].itemsToShow || promociones.length > breakpoints[700].itemsToShow"
                            #addons>
                            <navigation />
                        </template>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script scoped>

import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
export default {
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    props: {
        Itemsbar: {
            type: Object,
        },
    },
    data: () => ({
        // carousel settings
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        // breakpoints are mobile first
        // any settings not specified will fallback to the carousel settings
        breakpoints: {
            // 700px and up
            700: {
                itemsToShow: 3.5,
                snapAlign: 'center',
            },
            // 1024 and up
            1024: {
                itemsToShow: 5,
                snapAlign: 'center',
            },
        },
        promociones: {},
    }),
    methods: {
        getPromociones() {
            axios.get('/api/controllerpeticiones/getpromociones').then((response) => {
                //console.log('datos de promociones activas', response.data.filtrado[0].Prods); // Aquí accedes a la propiedad 'data' del objeto response
                this.promociones = response.data.filtrado[0].Prods
            }).catch(error => {
                console.error('Error al obtener promociones', error); // Manejo de errores
            });

        },
        formatItem(value) {
            // Reemplazar "/" con "<br>" para los saltos de línea
            if (!value) {
                return ""; // O manejar el caso en que los datos no son válidos
            }
            //console.log(value)
            //const boldLetters = value.replace(/([A-Z]+)/g, '<strong>$1</strong>');
            const formattedText = value.replace(/\s+/g, '<br>');

            return formattedText;
        },
    },
    mounted() {
        this.getPromociones()
    },

}

</script>